module.exports = __webpack_public_path__ + "static/media/jsg1968.4d1d4571.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/jsg1968.JPG
// module id = 692
// module chunks = 0